export default __webpack_public_path__ + "b5436129d83a0a2dd4304d84f4fce8c1.access-alarms-material.png";